import { css } from 'styled-components';
import token from 'styled-token';
import { focusMixin } from '../focusMixin';
import { inlineMediaQueryMixin } from '../inlineMediaQueryMixin';
import { spaceMixin } from '../spaceMixin';
var enableSnapCSS = inlineMediaQueryMixin('enableSnap', function (_ref) {
  var enableSnap = _ref.enableSnap;
  return css(["scroll-snap-type:", ";scroll-behavior:smooth;@media (prefers-reduced-motion:reduce){scroll-behavior:auto;}"], enableSnap ? 'x mandatory' : 'none');
});
var scrollOffsetCSS = inlineMediaQueryMixin('scrollOffset', function (props) {
  var scrollOffset = props.scrollOffset;
  return token({
    paddingTop: 'CarouselScrollContainer.scrollOffset.paddingTop',
    paddingBottom: 'CarouselScrollContainer.scrollOffset.paddingBottom',
    scrollPaddingY: 'CarouselScrollContainer.scrollOffset.scrollPaddingY'
  }, function (_ref2) {
    var _ref2$paddingTop = _ref2.paddingTop,
      paddingTop = _ref2$paddingTop === void 0 ? spaceMixin('xs')(props) : _ref2$paddingTop,
      _ref2$paddingBottom = _ref2.paddingBottom,
      paddingBottom = _ref2$paddingBottom === void 0 ? 18 : _ref2$paddingBottom,
      _ref2$scrollPaddingY = _ref2.scrollPaddingY,
      scrollPaddingY = _ref2$scrollPaddingY === void 0 ? 0 : _ref2$scrollPaddingY;
    return css(["padding:", "px ", " ", "px;scroll-padding:", "px ", ";"], paddingTop, spaceMixin(scrollOffset), paddingBottom, scrollPaddingY, spaceMixin(scrollOffset));
  })(props);
});

/** @class CarouselScrollContainerMixin */
/** @method */
export var CarouselScrollContainerMixin = function CarouselScrollContainerMixin(props) {
  return token('CarouselScrollContainer.margin', function (margin) {
    if (margin === void 0) {
      margin = 0;
    }
    return css(["list-style:none;margin:", "px;flex-wrap:nowrap;overflow-x:auto;::-webkit-scrollbar{display:none;}scrollbar-width:none;", " ", " ", ""], margin, enableSnapCSS(props), scrollOffsetCSS(props), focusMixin(props));
  })(props);
};